/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class SoftwareUpdate {
  constructor () {
    this.software_update_id = uuidV4()
    this.software_id=''
    this.dh_update=''
    this.tp_update='1'
    this.versao_update=''
    this.changelog_versao='1'
    this.changelog_resumido=''
    this.changelog_completo=''
    this.tp_instalacao=''
    this.perc_distribuicao=0
    this.alterar_distribuicao=false
    this.parar_distribuicao=false
    this.software_update_arquivos=[]
    this.software_update_clientes=[]
  }
}
